import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export const WORKING_COMPANY_ID_KEY = 'working_company_id';
export const WORKING_COMPANY_NAME_KEY = 'working_company_name';

@Injectable({
  providedIn: 'root'
})
export class WorkingCompanyService {
  private company$ = new BehaviorSubject<{ id: string; name: string } | null>(this.readStored());

  companyChange$ = this.company$.asObservable();

  getId(): string {
    const current = this.company$.value;
    if (!current || !current.id || current.id === '0') {
      return '';
    }
    return current.id;
  }

  getName(): string {
    const current = this.company$.value;
    return current && current.name ? current.name : '';
  }

  set(option: { id?: any; label?: string }) {
    const id = option && option.id != null ? String(option.id) : '';
    if (!id || id === '0') {
      this.clear();
      return;
    }
    const name = option.label || '';
    localStorage.setItem(WORKING_COMPANY_ID_KEY, id);
    localStorage.setItem(WORKING_COMPANY_NAME_KEY, name);
    this.company$.next({ id, name });
  }

  clear() {
    localStorage.removeItem(WORKING_COMPANY_ID_KEY);
    localStorage.removeItem(WORKING_COMPANY_NAME_KEY);
    this.company$.next(null);
  }

  bindFromList(companyList: any[]): string {
    const saved = this.getId();
    if (!saved || !companyList || !companyList.length) {
      return '';
    }
    const match = companyList.find(c => String(c.customer_id) === String(saved) && c.dbstatus !== false);
    return match ? String(match.customer_id) : '';
  }

  applyToHost(host: any, loadFn?: (id: string) => void): string {
    if (!host) {
      return '';
    }
    const list = host.getCompanyobj || host.getJourneyObj || host.CustomerData || host.companyObj || [];
    const working = this.bindFromList(list);
    if (!working) {
      return '';
    }
    const isUnset = (v: any) => v === '' || v === null || v === undefined || v === 'select' || v === 0 || v === '0';
    let applied = false;

    if (Object.prototype.hasOwnProperty.call(host, 'selectedCompany') && isUnset(host.selectedCompany)) {
      host.selectedCompany = working;
      applied = true;
    }
    if (Object.prototype.hasOwnProperty.call(host, 'companyId') && isUnset(host.companyId)) {
      host.companyId = working;
      applied = true;
    }
    if (Object.prototype.hasOwnProperty.call(host, 'selectedCompanyId') && isUnset(host.selectedCompanyId)) {
      host.selectedCompanyId = working;
      applied = true;
    }
    if (Object.prototype.hasOwnProperty.call(host, 'company') &&
        (typeof host.company === 'string' || typeof host.company === 'number') &&
        isUnset(host.company)) {
      host.company = working;
      applied = true;
    }
    if (Object.prototype.hasOwnProperty.call(host, 'companyID') &&
        !Object.prototype.hasOwnProperty.call(host, 'selectedCompany') &&
        isUnset(host.companyID)) {
      host.companyID = working;
      applied = true;
    }

    Object.keys(host).forEach((key) => {
      try {
        const val = host[key];
        if (val && typeof val.patchValue === 'function' && val.controls) {
          if (val.controls.selectedCompany && isUnset(val.controls.selectedCompany.value)) {
            val.patchValue({ selectedCompany: working });
            applied = true;
          } else if (val.controls.company && isUnset(val.controls.company.value)) {
            val.patchValue({ company: working });
            applied = true;
          } else if (val.controls.cid && isUnset(val.controls.cid.value)) {
            val.patchValue({ cid: working });
            applied = true;
          }
        }
      } catch (e) {}
    });

    if (applied && typeof loadFn === 'function') {
      loadFn(working);
    }
    return applied ? working : '';
  }

  private readStored() {
    const id = localStorage.getItem(WORKING_COMPANY_ID_KEY);
    if (!id || id === '0') {
      return null;
    }
    return {
      id,
      name: localStorage.getItem(WORKING_COMPANY_NAME_KEY) || ''
    };
  }
}
